var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.cstore.getCruiseBook.ok
        ? _c(_setup.Layout, {
            attrs: {
              slotInfoLinkRooms: true,
              CruiseBook: _setup.cstore.getCruiseBook.resolve,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "boat",
                  fn: function ({ hideInfoGrid }) {
                    return [
                      _c(_setup.Overview, {
                        attrs: {
                          CruiseBook: _setup.cstore.getCruiseBook.resolve,
                        },
                        on: { hideInfoGrid: (v) => hideInfoGrid(v) },
                      }),
                    ]
                  },
                },
                {
                  key: "after",
                  fn: function () {
                    return [
                      _c(
                        "transition",
                        { attrs: { name: "fade-up" } },
                        [
                          _setup.bookCabins.notEmpty()
                            ? _c(_setup.BookCabins, {
                                attrs: { ForOverview: true },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2023083651
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.cstore.getCruiseBook.wait
        ? _c(
            "div",
            { staticClass: "CruisePage__ifloader" },
            [_c(_setup.Loader, { staticClass: "CruisePage__loader" })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.cstore.getCruiseBook.reject
        ? _c("div", [_vm._v("! не удалось")])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }